import _ from "lodash";
import React from "react";

import { connect } from "react-redux";

import { graphql, compose } from "lib/apolloClient";

import { Tooltip } from "@toddle-edu/ds-web";
import { useTranslation } from "react-i18next";
import {
  getStaffPermsQueryVariables,
  getStaffRoleAccessFeedFromCache,
} from "../../../modules/ReviewerSetupModule";
import { getStaffRoleAccessFeedQuery } from "../../../modules/ReviewerSetupQueries";
import withLoader from "UIComponents/GqlWithLoader";
import { WarningTriangleFilled } from "SvgComponents";

const WarningTooltip = ({ showWarning }) => {
  const { t } = useTranslation(["journal"]);
  return showWarning ? (
    <div style={{ paddingTop: "4px" }}>
      <Tooltip
        tooltip={t("journal:create_only_permission_warning")}
        placement="bottomLeft"
        overlayInnerStyle={{ width: "260px" }}
        align={{ offset: [-30, -8] }}
      >
        <div>
          <WarningTriangleFilled />
        </div>
      </Tooltip>
    </div>
  ) : null;
};

const checkToShowWarning = staffEdges => {
  let showWarning = false;

  for (let i = 0; i < staffEdges.length; i++) {
    const staff = staffEdges[i].node;
    if (!_.size(staff.entityRelationMap.edges)) {
      continue;
    }
    for (let j = 0; j < staff.entityRelationMap.edges.length; j++) {
      const entityRelation = staff.entityRelationMap.edges[j].node;
      if (
        entityRelation.relatedEntity.isArchived &&
        _.size(staff?.entityRelationMap?.edges) === 1
      ) {
        showWarning = true;
        return true;
      }
    }
  }

  return showWarning;
};
const mapStateToProps = state => {
  const curriculumProgramId = _.get(
    state,
    "platform.currentCurriculumProgram.id",
    undefined
  );
  return {
    curriculumProgramId,
  };
};

export default compose(
  connect(mapStateToProps, null),
  graphql(getStaffRoleAccessFeedQuery, {
    name: "getStaffRoleAccessFeed",
    options: ({ curriculumProgramId }) => ({
      fetchPolicy: "cache-only",
      variables: getStaffPermsQueryVariables({ curriculumProgramId }),
    }),
    props: ({ getStaffRoleAccessFeed, ownProps: { curriculumProgramId } }) => {
      const staffFeedData = getStaffRoleAccessFeedFromCache(
        getStaffPermsQueryVariables({ curriculumProgramId })
      );
      const feedData = _.get(staffFeedData, "node.staff.edges", []);
      const { networkStatus, node } = getStaffRoleAccessFeed;
      const isLoading = _.includes([1, 2], networkStatus);
      const staffEdges = _.get(node, "staff.edges", []);
      const isData = !_.isEmpty(node) && (!_.isEmpty(staffEdges) || !isLoading);
      const showWarning = checkToShowWarning(staffEdges);
      return {
        feedData,
        isLoading:
          getStaffRoleAccessFeed["networkStatus"] == 1 ||
          getStaffRoleAccessFeed["networkStatus"] == 2 ||
          isLoading,
        isData,
        showWarning,
      };
    },
  }),

  withLoader
)(WarningTooltip);
